const carouselItems = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20paparazzi%20scene%20at%20night%20with%20camera%20flashes%20surrounding%20a%20luxury%20car%2C%20red%20carpet%20aesthetic%2C%20warm%20golden%20street%20lights%2C%20cinematic%20composition%2C%20mysterious%20urban%20night%20atmosphere%2C%20editorial%20photography%2C%20bold%20contrast%2C%20high%20drama&width=1000&height=600&seq=carousel-1&orientation=landscape',
    tag: '本周焦点',
    title: '2024娱乐圈塌房年鉴：谁是人设崩塌之王？',
    desc: '盘点本年度最具话题性的明星翻车事件，从顶流到老戏骨，揭秘那些被镜头记录下的尴尬瞬间与崩塌时刻。',
    date: '持续更新中',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Modern%20live%20streaming%20studio%20with%20multiple%20screens%20showing%20social%20media%20drama%2C%20dramatic%20red%20and%20dark%20lighting%2C%20ring%20lights%20and%20cameras%2C%20cinematic%20atmosphere%2C%20professional%20streamer%20setup%2C%20bold%20modern%20composition&width=1000&height=600&seq=carousel-2&orientation=landscape',
    tag: '深度专题',
    title: '直播带货翻车实录：当千万粉丝也救不了口误',
    desc: '从头部主播到腰部网红，细数今年直播圈最致命的翻车时刻。一句话毁掉千万合约，背后是品牌方的零容忍与粉丝的集体反噬。',
    date: '12月专题',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20investigation%20board%20with%20red%20strings%20connecting%20photos%20and%20documents%2C%20detective%20mystery%20aesthetic%2C%20dark%20moody%20lighting%2C%20warm%20amber%20accents%2C%20cinematic%20composition%2C%20modern%20editorial%20style&width=1000&height=600&seq=carousel-3&orientation=landscape',
    tag: '独家追踪',
    title: '选秀节目灰色产业链深度起底：票数造假的冰山一角',
    desc: '多位业内人士匿名爆料选秀行业背后不为人知的运作机制，从刷票工厂到内定排名，揭秘粉丝经济下的数据黑产。',
    date: '11月专题',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Social%20media%20war%20concept%20with%20smartphones%20displaying%20heated%20online%20arguments%2C%20dramatic%20red%20and%20dark%20lighting%2C%20digital%20culture%20conflict%2C%20bold%20editorial%20photography%2C%20cinematic%20suspense%2C%20modern%20internet%20culture%20aesthetic&width=1000&height=600&seq=carousel-4&orientation=landscape',
    tag: '年度盘点',
    title: '社交平台年度撕逼大战TOP10：谁赢了面子输了里子？',
    desc: '从微博到小红书，从抖音到B站，盘点2024年最具影响力的平台争议事件，看网络舆论如何改写当事人的命运。',
    date: '年度特辑',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center">
          焦点专题<i className="ri-focus-2-line text-primary-500 ml-2"></i>
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">深度追踪 · 持续更新</p>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-5">
          {carouselItems.map((item) => (
            <article key={item.id} className="group relative bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 cursor-pointer hover:border-primary-200/50 transition-colors">
              <div className="aspect-[5/3] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="flex items-center gap-2 mb-2 flex-wrap">
                  <span className="text-xs font-semibold bg-accent-500 text-background-50 px-2 py-0.5 rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="text-xs text-white/70">{item.date}</span>
                </div>
                <h3 className="text-base md:text-lg font-heading font-bold text-white leading-snug">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-xs md:text-sm text-white/80 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}